export default __webpack_public_path__ + "static/event-18285016654531d0ccbef7abbdf03c34.jpg";